<template>
<div>
    <homeassist :data="devices" :groupeddata="groupedData"/>
</div>
</template>
<script>
import Api from '@/services/Api.js'
import HomeAssist from "@/components/HomeAssist.vue";
export default {
    components: {
        homeassist: HomeAssist
    },
    data(){
        return {
            devices: [],
            groupedData: []
        }
    },
    created(){
        this.initialise()
    },
    methods: {
        initialise(){
            this.fetchHomeAssist()
        },
        fetchHomeAssist(){
        Api()
        .get('/gui/homeAssist')
        .then(async response=>{
            this.devices = response.data
            console.log(this.devices)
            let array = []
            let groupedData = await this.devices.reduce(function (r, o) {
        var m = o.serialNumber;
        let find = array.find(x=>x.serialNumber === m)
        if(find){
            let index = array.indexOf(find)
            array[index].data.push(o)
        } else {
            array.push({serialNumber: String(m), data: [o]})
        }
        // (r[m])? r[m].data.push(o) : array.push({serialNumber: String(m), data: [o]});
        return r;
    }, {});
    console.log(array)
    this.groupedData= array
        })
    }
    },
    
}
</script>